import axios from 'axios';
import { getAdminToken, getUserToken, isAdminAppPath } from '../context/AuthContext';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const API_URL =
    process.env.REACT_APP_API_URL ||
    (isLocal ? 'http://localhost:5000/api' : 'https://fastcv-back.onrender.com/api');

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = isAdminAppPath() ? getAdminToken() : getUserToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            if (isAdminAppPath()) {
                localStorage.removeItem('fcv_admin_token');
                localStorage.removeItem('fcv_admin');
                if (!window.location.pathname.includes('/bo-flashcv/login')) {
                    window.location.href = '/bo-flashcv/login';
                }
            } else {
                localStorage.removeItem('fcv_user_token');
                localStorage.removeItem('fcv_user');
                localStorage.removeItem('token');
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default api;
